const dev = {
  // API_ENDPOINT_URL: "http://localhost:8000/api/vendor",
  //  DOMAIN_API_URL: "http://localhost:5001",

  // DOMAIN_API_URs: "https://dom.technohamilton-shop",
  // API_ENDPOINT_URL: "https://api.technohamilton.store/api/vendor",
  // DOMAIN_URL_POINT: "https://api.technohamilton.store",

  DOMAIN_API_URL: "https://dom.hamilton-shop.online",
  API_ENDPOINT_URL: "https://api.hamilton-shop.online/api/vendor",
  DOMAIN_URL_POINT: "https://dns.hamilton-shop.online",
};

const prod = {
  API_ENDPOINT_URL: "http://localhost:8000/api/vendor",
  DOMAIN_API_URL: "https://dom.hamilton-shop.online",
  API_ENDPOINT_URL: "https://api.hamilton-shop.online/api/vendor",

  // DOMAIN_API_URL: "https://dom.technohamilton-shop",
  // API_ENDPOINT_URL: "https://api.technohamilton.store/api/vendor",
  // DOMAIN_URL_POINT: "https://api.technohamilton.store",

  // DOMAIN_API_URL: "https://dom.hamilton-shop.online",
  // API_ENDPOINT_URL: "https://api.hamilton-shop.online/api/vendor",
  // DOMAIN_URL_POINT: "https://dns.hamilton-shop.online",
};

const test = {
  API_ENDPOINT_URL: "http://localhost:8000/api/vendor",
  DOMAIN_API_URL: "https://dom.hamilton-shop.online",
  API_ENDPOINT_URL: "https://api.hamilton-shop.online/api/vendor",

  // DOMAIN_API_URL: "https://dom.technohamilton-shop",
  // API_ENDPOINT_URL: "https://api.technohamilton.store/api/vendor",
  // DOMAIN_URL_POINT: "https://api.technohamilton.store",

  // DOMAIN_API_URL: "https://dom.hamilton-shop.online",
  // API_ENDPOINT_URL: "https://api.hamilton-shop.online/api/vendor",
  // DOMAIN_URL_POINT: "https://dns.hamilton-shop.online",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
